import PropTypes from "prop-types";
import Avatar from "@/components/common/Avatar";

const ActivityItem = ({ avatar, activity }) => {
  return (
    <div className="flex items-center gap-8">
      {" "}
      {/* Changed from items-start to items-center */}
      {/* Time Circle */}
      <div className="relative">
        <div className="w-24 h-24 rounded-full bg-white border border-[#EAECF0] flex flex-col items-center justify-center">
          <span className="text-medium font-bold text-lighterGrey">
            {activity.time}
          </span>
          <span className="text-small text-lighterGrey font-normal mt-1">
            Ago
          </span>
        </div>
      </div>
      {/* Activity Content */}
      <div className="flex-1 flex flex-col justify-between">
        {" "}
        {/* Removed pt-4 and added flex structure */}
        <div className="flex flex-wrap items-center text-left gap-1 text-regular mb-4">
          <p className="font-medium text-regular">
            <span className="text-primary font-bold">Temitope</span> Marked the
            <span className="text-primary font-bold"> task </span>
            &quot;{activity.task}&quot; as{" "}
            <span className="text-green"> Completed</span>
          </p>
        </div>
        {/* Assigned By Section */}
        <div className="flex text-left items-start gap-2">
          <Avatar size={36} src={avatar} className="border-2 border-gray-100" />
          <div>
            <span className="text-small text-lighterGrey">
              Task assigned by
            </span>
            <div className="text-small font-medium text-darkGrey">
              {activity.assignedBy}
            </div>
          </div>
        </div>
        <div className="mt-6">
          <hr />
        </div>
      </div>
    </div>
  );
};

ActivityItem.propTypes = {
  avatar: PropTypes.string,
  activity: PropTypes.shape({
    time: PropTypes.string,
    task: PropTypes.string,
    assignedBy: PropTypes.string,
    assignedByImage: PropTypes.string,
  }),
};

export default ActivityItem;
